import {
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material'
import { TrendingUp, TrendingDown } from '@mui/icons-material'

const currencyBRL = (n) =>
    (Number(n) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const formatDate = (iso) => {
    try {
        const d = new Date(iso)
        if (isNaN(d.getTime())) return '---'
        const dd = String(d.getDate()).padStart(2, '0')
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const yyyy = d.getFullYear()
        return `${dd}/${mm}/${yyyy}`
    } catch {
        return '---'
    }
}

const RecentTransactions = ({ entries = [] }) => (
    <Card
        sx={{
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            borderRadius: 3,
        }}
    >
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2.5,
                    pb: 1.5,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1E293B' }}>
                    Últimas Transações
                </Typography>
                <Button
                    href="/financeiro/extrato"
                    variant="text"
                    size="small"
                    sx={{ color: '#3B82F6', textTransform: 'none', fontWeight: 600 }}
                >
                    Ver todas →
                </Button>
            </Box>

            {entries.length === 0 ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#94A3B8' }}>
                        Nenhuma transação recente
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ px: 1 }}>
                    {entries.slice(0, 10).map((entry, i) => (
                        <Box key={entry.id ?? i}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    py: 1.5,
                                    px: 1.5,
                                }}
                            >
                                {/* Icon + description */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        flex: 1,
                                        minWidth: 0,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: '10px',
                                            bgcolor:
                                                entry.valor >= 0 ? '#22C55E15' : '#EF444415',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                        }}
                                    >
                                        {entry.valor >= 0 ? (
                                            <TrendingUp sx={{ fontSize: 18, color: '#22C55E' }} />
                                        ) : (
                                            <TrendingDown sx={{ fontSize: 18, color: '#EF4444' }} />
                                        )}
                                    </Box>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ fontWeight: 500, color: '#1E293B' }}
                                            noWrap
                                        >
                                            {entry.descricao}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                                            {formatDate(entry.data)}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Value */}
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 600,
                                        ml: 2,
                                        color: entry.valor >= 0 ? '#22C55E' : '#EF4444',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {entry.valor >= 0 ? '+' : ''}
                                    {currencyBRL(entry.valor)}
                                </Typography>
                            </Box>
                            {i < entries.length - 1 && <Divider />}
                        </Box>
                    ))}
                </Box>
            )}
        </CardContent>
    </Card>
)

export default RecentTransactions
